import { i18nInstance } from './i18n.js';
import { setDefaultOptions } from 'date-fns';
import dateLocales from '../constants/dateLocales.js';

// @ts-nocheck

var instance = i18nInstance().getInstance();
instance.loadTranslations = function () {
  if (Object.hasOwnProperty.call(window, 'translations') && Object.keys(window.translations).length !== 0) {
    Object.values(window.translations).forEach(function (translation) {
      Object.keys(translation).forEach(function (language) {
        instance.addResourceBundle(language, 'defaultNamespace', translation[language]);
      });
    });
  }
  setDefaultOptions({
    locale: dateLocales[instance.language] || dateLocales.en
  });
};
if (typeof window !== 'undefined') {
  instance.loadTranslations();
}
var i18n = instance;
export { i18n };